import { render, staticRenderFns } from "./StoreNavigationBar.vue?vue&type=template&id=463a52c9&scoped=true"
import script from "./StoreNavigationBar.vue?vue&type=script&lang=ts"
export * from "./StoreNavigationBar.vue?vue&type=script&lang=ts"
import style0 from "./StoreNavigationBar.vue?vue&type=style&index=0&id=463a52c9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "463a52c9",
  null
  
)

export default component.exports